import React from 'react';
import Tooltip from '@mui/material/Tooltip';

const withProtocol = (url) => {
  if (!url) return '';
  return /^https?:\/\//i.test(url.trim()) ? url.trim() : `https://${url.trim()}`;
};

const PERSON_SOCIALS = [
  { key: 'linkedinUrl', icon: 'fab fa-linkedin', label: 'Personal LinkedIn' },
];

const COMPANY_SOCIALS = [
  { key: 'companyLinkedin', icon: 'fab fa-linkedin', label: 'Company LinkedIn' },
  { key: 'companyTwitter', icon: 'fab fa-x-twitter', label: 'Twitter / X' },
  { key: 'companyFacebook', icon: 'fab fa-facebook', label: 'Facebook' },
  { key: 'companyInstagram', icon: 'fab fa-instagram', label: 'Instagram' },
  { key: 'companyYoutube', icon: 'fab fa-youtube', label: 'YouTube' },
  { key: 'companyWikipedia', icon: 'fab fa-wikipedia-w', label: 'Wikipedia' },
  { key: 'companyDomain', icon: 'fa fa-globe', label: 'Website' },
];

// type: 'person' | 'company' | 'all' (default 'all' for drawer use)
const LeadSocialIcons = ({ lead, type = 'all', className }) => {
  const list = type === 'person' ? PERSON_SOCIALS : type === 'company' ? COMPANY_SOCIALS : [...PERSON_SOCIALS, ...COMPANY_SOCIALS];
  const icons = list.filter(s => lead[s['key']]);
  if (!icons.length) return null;

  return (
    <div className={`lead-social-icons ${className || ''}`}>
      {icons.map(s => (
        <Tooltip key={s['key']} title={s['label']} placement="top" arrow>
          <a
            className="lead-social-icon-link"
            href={withProtocol(lead[s['key']])}
            target="_blank"
            rel="noreferrer"
            onClick={e => e.stopPropagation()}
          >
            <i className={s['icon']} />
          </a>
        </Tooltip>
      ))}
    </div>
  );
};

export default LeadSocialIcons;
